import { AnalyticsBrowser } from '@segment/analytics-next';

export const analytics = AnalyticsBrowser.load(
  {
    writeKey: SEGMENT_WRITE_KEY,
    cdnURL: 'https://sapi.quashed.co.nz/cdn',
  },
  {
    integrations: {
      'Segment.io': {
        apiHost: 'sapi.quashed.co.nz/v1',
        protocol: 'https',
      },
    },
  },
);
